import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import NavigationDrawer from '@/components/NavigationDrawer.vue';
let HivesNavigation = class HivesNavigation extends Vue {
    constructor() {
        super(...arguments);
        this.items = [
            {
                title: 'Introduction',
                icon: 'fa-journal-whills',
                route: '/rules/wh'
            },
            {
                title: '1. Step-By-Step Factions',
                icon: 'fa-beer',
                route: '/rules/wh/stepByStepFactions'
            },
            {
                title: '2. Entertainment and Downtime',
                icon: 'fa-pencil-ruler',
                route: '/rules/wh/downtime'
            },
            {
                title: '3. Factions and Membership',
                icon: 'fa-globe',
                route: '/rules/wh/factionsAndMembership'
            },
            {
                title: '4. Using Ability Scores',
                icon: 'fa-dice-d20',
                route: '/rules/wh/abilityScores'
            },
            {
                title: '5. Equipment',
                icon: 'fa-shopping-bag',
                route: '/rules/wh/equipment'
            },
            {
                title: '6. Customization Options',
                icon: 'fa-tools',
                route: '/rules/wh/customizationOptions'
            },
            {
                title: '7. Enhanced Items',
                icon: 'fa-hat-wizard',
                route: '/rules/wh/enhancedItems'
            },
            {
                title: '8. Tool Proficiencies',
                icon: 'fa-mortar-pestle',
                route: '/rules/wh/toolProficiencies'
            },
            {
                title: 'Changelog',
                icon: 'fa-list',
                route: '/rules/wh/changelog'
            }
        ];
    }
};
HivesNavigation = __decorate([
    Component({
        components: {
            NavigationDrawer
        }
    })
], HivesNavigation);
export default HivesNavigation;
